/* ManageDashboardsRenderer.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const CheckboxControl = uiCore.Control.Boolean.InputCheckbox;
const ButtonControl = uiCore.Control.Action.Button;
// const InputRadioControl = uiCore.Control.OptionSelection.Single.InputRadio;
const ImageUploadControl = require("../../commoncomponents/imageUpload/ImageUploadComponent");

class ManageRolesRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("manage-dashboards-gl");
        this._rootElem.component = this._model;

        this._headerElem = document.createElement("h1");
        this._headerElem.innerText = "Dashboards";
        this._rootElem.appendChild(this._headerElem);

        this._editorWrapper = document.createElement("div");
        this._editorWrapper.classList.add("wrapper");

        this._clearPatches = false;

        this._imageUploadControl = undefined;
        this._imageUploadControlContainer = document.createElement("div");
        this._imageUploadControlContainer.classList.add("image-upload-container");
        this._imageUploadControlContainer.classList.add("hidden"); //hide by default

        this._dashboardEnabledCheckBox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable Dashboard Preferences for this Organization",
            title: "Allow specific dashboard preferences for this organization",
            disabled: false
        });

        this._enableDashboardImagesCheckBox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable custom Dashboard Images",
            title: "Allow the addition of a custom image to the My Dashboards title bar (Only available in the topmmost organization)",
            disabled: false
        });

        this._enableSessionTimeoutCheckBox = new CheckboxControl({
            darkTheme: true,
            labelShown: true,
            label: "Enable/Disable session timeout in fullscreen mode",
            disabled: false
        });

        // this._defaultTheme = new InputRadioControl({
        //     darkTheme: true,
        //     horizontal: true,
        //     options: [{
        //             label: "Light",
        //             value: "LIGHT"
        //         },
        //         {
        //             label: "Dark",
        //             value: "DARK"
        //         }
        //     ],
        //     value: true
        // });
        // this._enableFavouriteHotkeysCheckbox = new CheckboxControl({
        //     darkTheme: true,
        //     labelShown: true,
        //     label: "Enable <span class='key main'>Alt</span> <span class='key'><</span><span class='connect'></span><span class='key'>></span> to navigate back and forth between favorite dashboards",
        //     disabled: false
        // });
        // this._enableFavouriteShortcutsCheckbox = new CheckboxControl({
        //     darkTheme: true,
        //     labelShown: true,
        //     label: "Enable <span class='key main'>Alt</span> <span class='key'>0</span><span class='connect'></span><span class='key'>9</span> to directly open favorite dashboard",
        //     disabled: false
        // });


        this._actionsContainer = document.createElement("div");
        this._actionsContainer.classList.add("control-buttons");
        this._cancelBtn = new ButtonControl({
            disabled: true,
            invalid: false,
            visible: true,
            darkTheme: true,
            label: "Cancel"
        });
        this._saveBtn = new ButtonControl({
            disabled: true,
            invalid: false,
            visible: true,
            darkTheme: true,
            label: "Save",
            active: false
        });
        this._actionsContainer.appendChild(this._cancelBtn.renderer.getRootElement());
        this._actionsContainer.appendChild(this._saveBtn.renderer.getRootElement());
        this._imageUploadCallback = this._imageUploadCallback.bind(this);


        this._registerListeners();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        this._unregisterListeners();


        const controls = [
            this._dashboardEnabledCheckBox,
            this._enableSessionTimeoutCheckBox,
            this._defaultTheme,
            this._enableFavouriteHotkeysCheckbox,
            this._enableFavouriteShortcutsCheckbox,
            this._cancelBtn,
            this._saveBtn
        ];

        if(this._imageUploadControl) {
            controls.push(this._imageUploadControl);
        }

        return Promise.all(_.invokeMap(controls, "shutdown")).then(() => {
            this._model = undefined;
            this._headerElem.remove();
            this._headerElem = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            this._clearPatches = undefined;

            this._dashboardEnabledCheckBox = undefined;
            this._enableSessionTimeoutCheckBox = undefined;
            this._defaultTheme = undefined;
            this._enableFavouriteHotkeysCheckbox = undefined;
            this._enableFavouriteShortcutsCheckbox = undefined;
            this._actionsContainer = undefined;
            this._cancelBtn = undefined;
            this._saveBtn = undefined;
            this._imageUploadControl = undefined;
            this._imageUploadControlContainer = undefined;
        });
    }

    _registerListeners() {
        this._dashboardEnabledCheckBox.on("UserValue", this._onDashboardEnabledCheckboxChange.bind(this));
        this._enableDashboardImagesCheckBox.on("UserValue", this._onEnableDashboardImages.bind(this));
        this._enableSessionTimeoutCheckBox.on("UserValue", this._onEnableSessionTimeoutCheckboxChange.bind(this));
        // this._defaultTheme.on("UserValue", this._onDefaultThemeChange.bind(this));
        // this._enableFavouriteHotkeysCheckbox.on("UserValue", this._onEnableFavouriteHotkeysChange.bind(this));
        // this._enableFavouriteShortcutsCheckbox.on("UserValue", this._onEnableFavouriteShortcutsChange.bind(this));

        this._cancelBtn.on("UserClick", this._onCancelClick.bind(this));
        this._saveBtn.on("UserClick", this._onSaveClick.bind(this));

        this._model.on("Dirty", this._onDirtyStateChange.bind(this));

        this._model.on("DataUpdated", this._onDataUpdated.bind(this));
    }

    _unregisterListeners() {
        this._dashboardEnabledCheckBox.removeAllListeners("UserValue");
        this._enableDashboardImagesCheckBox.removeAllListeners("UserValue");
        this._enableSessionTimeoutCheckBox.removeAllListeners("UserValue");
        // this._defaultTheme.removeAllListeners("UserValue");
        // this._enableFavouriteHotkeysCheckbox.removeAllListeners("UserValue");
        // this._enableFavouriteShortcutsCheckbox.removeAllListeners("UserValue");

        this._cancelBtn.removeAllListeners("UserClick");
        this._saveBtn.removeAllListeners("UserClick");

        this._model.removeAllListeners("Dirty");

        this._model.removeAllListeners("DataUpdated");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (this.model) {
            return this.model.whenModelIsReady().then(() => {

                this._renderDashboardSettings();
                this._populateData();
               return Promise.resolve();
            });
        }
    }

  

    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _imageUploadCallback(data) {
        if(data !== this._model._dashboardPrefEntity.defaultImage) {
            this._model._dashboardPrefEntity.setDefaultImage(data);
            this._model._tempPatches = false;
            this._enableDisableSaveCancel();
        }
    }
    _renderDashboardSettings() {
        if(!this._model._EnableDisableDashboard) {
            this._dashboardEnabledCheckBox.renderer._rootElem.classList.add('hide');
        }
        this._rootElem.appendChild(this._dashboardEnabledCheckBox.renderer._rootElem);
        this._rootElem.appendChild(this._editorWrapper);
        this._editorWrapper.appendChild(this._createEnableDashboardImageSection());
        // this._enableSessionTimeoutCheckBox.renderer._rootElem.classList.add("session-check-box");
        // this._rootElem.appendChild(this._enableSessionTimeoutCheckBox.renderer._rootElem);
        // this._editorWrapper.appendChild(this._createThemeSection());

        // this._editorWrapper.appendChild(this._createEnableDisableHotkeysSection());

        this._rootElem.appendChild(this._actionsContainer);
    }

    _createEnableDashboardImageSection() {
        const _enableDashboardImageSection = document.createDocumentFragment();

        const _enableDashboardImageWrapper = document.createElement("div");
        _enableDashboardImageWrapper.appendChild(this._enableDashboardImagesCheckBox.renderer.getRootElement());
        if(!this._model._dashboardPrefEntity.defaultImage) {
           this._model._dashboardPrefEntity.setDefaultImage(this._model._defaultDashboardImage);
           this._model._tempPatches = false;
        }

        this._imageUploadControl = new ImageUploadControl({
            callback: this._imageUploadCallback,
            MUF: this._model.userFeedback,
            image: this._model._dashboardPrefEntity.defaultImage,
            defaultImg: this._model._defaultDashboardImage,
            noImageText: "",
            description: "Add a default Dashboard Image",
            title: "Add a custom image to the My Dashboards title bar for the organization",
            deleteOpts: {
                btnText: "Delete Image",
                veilTitle: "Delete",
                veilMsg: "Are you sure you want to delete the default Dashboard Image?"
            },
            editOpts: {
                title: "Edit Image",
                description: "Click-and-drag or zoom to optimize the default Dashboard Image",
                okText: "Add",
                cancelText: "Cancel"
            }
        });
        this._imageUploadControlContainer.appendChild(this._imageUploadControl.renderer._rootElem);
        _enableDashboardImageWrapper.appendChild(this._imageUploadControlContainer);

        _enableDashboardImageSection.appendChild(_enableDashboardImageWrapper);
        return this._createSection(_enableDashboardImageSection, {
            title: "Dashboard Images",
            className: "dashboard-imaage-section",
            bordered: false
        });
    }

    _createThemeSection() {
        const _defaultThemeSection = document.createDocumentFragment();

        const _defaultThemeWrapper = document.createElement("div");
        _defaultThemeWrapper.appendChild(this._defaultTheme.renderer.getRootElement());

        _defaultThemeSection.appendChild(_defaultThemeWrapper);

        return this._createSection(_defaultThemeSection, {
            title: "Default Theme",
            className: "default-theme-section",
            bordered: false
        });
    }

    _createEnableDisableHotkeysSection() {
        const _enableDisableHotkeysSection = document.createDocumentFragment();

        const _enableDisableHotkeysWrapper = document.createElement("div");
        _enableDisableHotkeysWrapper.appendChild(this._enableFavouriteHotkeysCheckbox.renderer.getRootElement());
        _enableDisableHotkeysWrapper.appendChild(this._enableFavouriteShortcutsCheckbox.renderer.getRootElement());

        _enableDisableHotkeysSection.appendChild(_enableDisableHotkeysWrapper);

        return this._createSection(_enableDisableHotkeysSection, {
            title: "Keyboard Shortcuts",
            className: "hotkeys-section",
            bordered: false
        });
    }

    _createSection(content, options = {}) {
        const section = document.createElement("section");
        section.className = options.className || "";
        section.classList.toggle("bordered", !!options.bordered);

        if (options.title) {
            const title = document.createElement("h2");
            title.innerText = options.title;
            section.appendChild(title);
        }
        section.appendChild(content);
        return section;
    }

    _populateData(data, saveToPrefs = false) {
        let allowDisableSessionTimeout, defaultImage, enableImageUpload, enable;
        if (data) {
            allowDisableSessionTimeout = data.allowDisableSessionTimeout;
            defaultImage = data.defaultImage; 
            enableImageUpload = data.enableImageUpload;
            enable = data.enable;
        } else {
            allowDisableSessionTimeout = this._model._dashboardPrefEntity.getAllowDisableSessionTimeout();
            defaultImage = this._model._dashboardPrefEntity.getDefaultImage();
            enableImageUpload = this._model._dashboardPrefEntity.getEnableImageUpload();
            enable = this._model._dashboardPrefEntity.getEnable();
        }
        
        this._dashboardEnabledCheckBox.setValue(enable);

        this._enableSessionTimeoutCheckBox.setValue(allowDisableSessionTimeout);
        this._enableDashboardImagesCheckBox.setValue(enableImageUpload);
        if(enableImageUpload) {
            this._imageUploadControlContainer.classList.remove("hidden");
        } else {
            this._imageUploadControlContainer.classList.add("hidden");
        }
        // this._defaultTheme.setValue(defaultTheme);
        // this._enableFavouriteHotkeysCheckbox.setValue(enableFavoriteHotkeys);
        // this._enableFavouriteShortcutsCheckbox.setValue(enableFavoriteShortcuts);
        this._imageUploadControl.emit("UpdateImage", defaultImage);

        if(saveToPrefs) {
            this._setValuesToDashboard({ allowDisableSessionTimeout, 
                defaultImage,
                // defaultTheme, 
                // enableFavoriteHotkeys, 
                // enableFavoriteShortcuts, 
                enableImageUpload,
                enable
            });
        }

        this._enableDisableDashboardPrefEdit(enable);
        if(!this._model._hasDashboardManageAccess) {
            this._dashboardEnabledCheckBox.setDisabled(true);
        } else {
            this._dashboardEnabledCheckBox.setDisabled(false);
        }

    }

    _setValuesToDashboard({
        // defaultTheme, 
        // enableFavoriteHotkeys, 
        // enableFavoriteShortcuts, 
        enableImageUpload,
        enable
    }) {
        if(!this._model._dashboardPrefEntity) {
            return;
        }
        const dashBoard = this._model._dashboardPrefEntity;
        // dashBoard.setDefaultTheme(defaultTheme);
        // dashBoard.setEnableFavoriteHotkeys(enableFavoriteHotkeys);
        // dashBoard.setEnableFavoriteShortcuts(enableFavoriteShortcuts);
        dashBoard.setEnableImageUpload(enableImageUpload);
        dashBoard.setEnable(enable);
    }
    
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _displayDisableDashboardVeil() {
        return this._model._uiUtils.showDeleteConfirmDialog({
            message: "The Dashboard Preferences will be updated to use the configuration defined by the parent organization. The default Dashboard Image for this organization will be deleted. Do you want to continue?",
            confirmButtonName: "Confirm",
            cancelButtonName: "Cancel"
        });
    }
    _setDashboardEnablePref(value) {
        this._model._dashboardPrefEntity.setEnable(value);
        this._model._tempPatches = false;
        this._enableDisableDashboardPrefEdit(value);
        this._onSaveClick.call(this);
    }
    _onDashboardEnabledCheckboxChange(value) {
        // console.log("called: " + value);
        if(value) {
            this._setDashboardEnablePref(value);
        } else {
            this._displayDisableDashboardVeil()
            .then(() => {
                this._model._dashboardPrefEntity.setEnable(false);
                return this._model._dashboardPrefEntity.update();
            })
            .then(() => this.model.whenModelIsReady())
            .then(() => {
                this._populateData();
                this._setDashboardEnablePref(false);
            })
            .catch( err => {
                this._model._logger.info(err);
                this._dashboardEnabledCheckBox.setValue(true, false);
                //if user rejected close
            });
        }
    }

    _enableDisableDashboardPrefEdit(enabled = false) {
        if(this._model._hasDashboardManageAccess) {
            if(!enabled && this._model._EnableDisableDashboard) {
                this._editorWrapper.classList.add("disabled");
            } else {
                this._editorWrapper.classList.remove("disabled");
            }
        } else {
            this._editorWrapper.classList.add("disabled");
        }
    }

    _onEnableDashboardImages(value) {
        this._model._dashboardPrefEntity.setEnableImageUpload(value);
        this._model._tempPatches = false;
        if(value) {
            this._imageUploadControlContainer.classList.remove("hidden");
        } else {
            this._imageUploadControlContainer.classList.add("hidden");
        }
        this._enableDisableSaveCancel();
    }

    _onEnableSessionTimeoutCheckboxChange(value) {
        this.model._dashboardPrefEntity.setAllowDisableSessionTimeout(value);
        this._model._tempPatches = false;
        this._enableDisableSaveCancel();
    }

    // _onDefaultThemeChange(value) {
    //     this.model._dashboardPrefEntity.setDefaultTheme(value);
    //     this._enableDisableSaveCancel();
    // }

    // _onEnableFavouriteHotkeysChange(value) {
    //     this.model._dashboardPrefEntity.setEnableFavoriteHotkeys(value);
    //     this._enableDisableSaveCancel();
    // }

    // _onEnableFavouriteShortcutsChange(value) {
    //     this.model._dashboardPrefEntity.setEnableFavoriteShortcuts(value);
    //     this._enableDisableSaveCancel();
    // }

    _onCancelClick() {
        this._clearPatches = true;
        this._imageUploadControl.emit("UpdateImage", this._model._dashboardPrefEntity.defaultImage);
        this._model.clearPatches();
    }

    _onSaveClick() {
        this._model.saveDashboardPrefs();
    }

    _onDirtyStateChange() {
        this._enableDisableSaveCancel();
        if(this._clearPatches) {
            this._populateData();
            this._clearPatches = false;
        }
    }

    _onPatchesCleared() {
        this._populateData();
        this._enableDisableSaveCancel();
    }

    _onDataUpdated() {
        if(!this._model._EnableDisableDashboard) {
            this._dashboardEnabledCheckBox.renderer._rootElem.classList.add('hide');
        } else {
            this._dashboardEnabledCheckBox.renderer._rootElem.classList.remove('hide');
        }
        this._populateData();
        this._enableDisableSaveCancel();
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _enableDisableSaveCancel() {
        if(this._model.Dirty && this._model._tempPatches === false) {
            this._cancelBtn.setDisabled(false);
            this._saveBtn.setDisabled(false);
        } else {
            this._cancelBtn.setDisabled(true);
            this._saveBtn.setDisabled(true);
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = ManageRolesRenderer;
